var render, staticRenderFns
import script from "./fancyDynamicTableItem.vue?vue&type=script&lang=js"
export * from "./fancyDynamicTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fancyDynamicTableItem.vue"
export default component.exports